(() => {
'use strict';
const configNode=document.getElementById('dtw-shop-config');
if(!configNode)return;
const config=JSON.parse(configNode.textContent);
function weekPhase(now, hasWeekCode) {
    const early = Date.parse('2026-11-03T09:00:00+01:00');
    const start = Date.parse('2026-11-05T09:00:00+01:00');
    const end = Date.parse('2026-11-16T00:00:00+01:00');
    if (now >= end) return 'ended';
    if (now >= start) return 'active';
    if (now >= early && hasWeekCode) return 'early';
    return 'upcoming';
  }
const initialPhase=weekPhase(Date.now(),false);
const banner=document.getElementById('dtw-shop-banner');
const root=document.querySelector('[data-dtw-root]');
const active=initialPhase==='active';
let shown=false, weekEnabled=active;
function updateTicketCollection(){
 document.querySelectorAll('.tf-offer strong, #tf-fair > strong').forEach(node=>node.textContent=config.copy.tickets);
 document.querySelectorAll('.tf-offer > div > span, #tf-fair > p:last-child').forEach(node=>node.textContent=config.copy.auto+' '+config.copy.until);
 document.querySelectorAll('a[href*="/discount/aktion20"]').forEach(updateOldLink);
}
function updateOldLink(link){
 const url=new URL(link.href,location.href);
 if(url.origin===location.origin&&/\/discount\/aktion20$/i.test(url.pathname)){url.pathname=url.pathname.replace(/aktion20$/i,'TENOR40');link.href=url.href;}
}
document.addEventListener('click',event=>{const link=event.target.closest('a[href]');if(weekEnabled&&link)updateOldLink(link);},true);
function showProductOffer(){
 if(shown||!config.kind)return;
 shown=true;
 const title=config.copy[config.kind];
 const box=document.createElement('div');
 box.className='dtw-product-offer';
 const heading=document.createElement('strong');heading.textContent=title;
 const text=document.createElement('span');text.textContent=config.copy.auto;
 const end=document.createElement('small');end.textContent=config.copy.until;
 box.append(heading,text,end);
 const offer=document.querySelector('.fair-offer, .opti2-offer, .tdt-ticket__offer');
 if(offer&&config.kind==='tickets'){
  offer.replaceChildren(box);
  offer.setAttribute('aria-label',title);
 }else{
  const buy=document.querySelector('.tdt-mp__buy, #add, .lmad-buy')||document.querySelector('.product-single__meta form[action*="/cart/add"], form[action*="/cart/add"], [data-open-seatmap]');
  if(buy)buy.before(box);
 }
 if(config.kind==='tickets'){
  document.querySelectorAll('.tdt-photo-benefit, .tdt-ticket__sticky > span > strong').forEach(node=>node.textContent=title);
  document.querySelectorAll('.tdt-ticket__sticky[aria-label]').forEach(node=>node.setAttribute('aria-label',node.getAttribute('aria-label').replace(/[-−]?20\s*(?:Euro|€)\s*Bestellvorteil/gi,title)));
  document.querySelectorAll('.opti2-panel-body h3').forEach(node=>{
   if(/Bestellvorteil|order discount|ordrerabat/i.test(node.textContent)){
    node.textContent=config.copy.faq;
    if(node.nextElementSibling?.tagName==='P')node.nextElementSibling.textContent=config.copy.auto+' '+config.copy.detail;
   }
  });
  document.querySelectorAll('.tdt-ticket__offer').forEach(node=>{
   if(node!==offer&&/20|aktion20/i.test(node.textContent))node.hidden=true;
  });
 }
}
if(active){
 document.documentElement.classList.add('dtw-shop-active');
 if(banner&&!root){
  const header=document.querySelector('.dtw-nav, #shopify-section-header, .shopify-section-group-header-group:last-of-type, header.site-header, .smt-header, .lmad-header, .store > header');
  if(header)header.after(banner);else document.body.prepend(banner);
  banner.hidden=false;
 }
 showProductOffer();
 updateTicketCollection();
}
if(!active&&(config.kind||document.querySelector('.tf-root'))&&Date.now()>=Date.parse('2026-11-03T09:00:00+01:00')&&Date.now()<Date.parse('2026-11-16T00:00:00+01:00')&&window.tdtReadTicketBenefit){
 window.tdtReadTicketBenefit().then(cart=>{
  if((cart?.discount_codes||[]).some(code=>/^tenor(?:20|40)$/i.test(code.code))){weekEnabled=true;showProductOffer();updateTicketCollection();}
 }).catch(()=>{});
}
function checkBoundary(){
 if(weekPhase(Date.now(),false)!==initialPhase)location.reload();
}
setInterval(checkBoundary,1000);
document.addEventListener('visibilitychange',()=>{if(!document.hidden)checkBoundary();});
window.addEventListener('pageshow',checkBoundary);
})();
